/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportCategory } from './ReportCategory';
import {
    ReportCategoryFromJSON,
    ReportCategoryFromJSONTyped,
    ReportCategoryToJSON,
    ReportCategoryToJSONTyped,
} from './ReportCategory';
import type { GetReportParameter } from './GetReportParameter';
import {
    GetReportParameterFromJSON,
    GetReportParameterFromJSONTyped,
    GetReportParameterToJSON,
    GetReportParameterToJSONTyped,
} from './GetReportParameter';

/**
 * 
 * @export
 * @interface GetReportResponse
 */
export interface GetReportResponse {
    /**
     * 
     * @type {string}
     * @memberof GetReportResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetReportResponse
     */
    displayName: string;
    /**
     * 
     * @type {ReportCategory}
     * @memberof GetReportResponse
     */
    category: ReportCategory;
    /**
     * 
     * @type {Array<GetReportParameter>}
     * @memberof GetReportResponse
     */
    parameters: Array<GetReportParameter>;
    /**
     * 
     * @type {boolean}
     * @memberof GetReportResponse
     */
    favourite: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReportResponse
     */
    isActive: boolean;
}



/**
 * Check if a given object implements the GetReportResponse interface.
 */
export function instanceOfGetReportResponse(value: object): value is GetReportResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    if (!('favourite' in value) || value['favourite'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetReportResponseFromJSON(json: any): GetReportResponse {
    return GetReportResponseFromJSONTyped(json, false);
}

export function GetReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'displayName': json['displayName'],
        'category': ReportCategoryFromJSON(json['category']),
        'parameters': ((json['parameters'] as Array<any>).map(GetReportParameterFromJSON)),
        'favourite': json['favourite'],
        'isActive': json['isActive'],
    };
}

export function GetReportResponseToJSON(json: any): GetReportResponse {
    return GetReportResponseToJSONTyped(json, false);
}

export function GetReportResponseToJSONTyped(value?: GetReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'displayName': value['displayName'],
        'category': ReportCategoryToJSON(value['category']),
        'parameters': ((value['parameters'] as Array<any>).map(GetReportParameterToJSON)),
        'favourite': value['favourite'],
        'isActive': value['isActive'],
    };
}

